import { Observable } from 'rxjs';
import { ActionsObservable } from 'redux-observable';

import { selectOrganization } from 'entities/user/selectors';
import VolunteersApi from 'entities/volunteers/api';
import { showErrorAction, showMessageAction } from 'containers/Notification/actions';

import {
  fetchSuccessAction,
  fetchFailedAction,
  verifySuccessAction,
  verifyFailedAction,
  SendPacUploadEmailAction,
  sendPacUploadEmailFailedAction,
  sendPacUploadEmailSuccessAction,
} from './actions';
import { INIT, VERIFY, SET_FETCH_PARAMS, SEND_PAC_UPLOAD_EMAIL_NOTIFICATION } from './constants';
import { selectFetchParams } from './selectors';

const fetch = (action$, store) =>
  action$.ofType(INIT, SET_FETCH_PARAMS).mergeMap(() => {
    const state = store.getState();
    const fetchParams = selectFetchParams(state);
    const sort = fetchParams.get('sort');
    const order = fetchParams.get('order');
    const search = fetchParams.get('search');
    const pageNum = fetchParams.get('pageNum');
    const limit = fetchParams.get('limit');
    const status = fetchParams.get('status');
    const departments = fetchParams.get('departments').toArray();
    const locations = fetchParams.get('locations').toArray();
    const skip = limit * pageNum;

    const organization = selectOrganization(state);
    if (!organization) {
      return Observable.empty();
    }
    return VolunteersApi.fetch(organization, {
      limit,
      skip,
      sort,
      order,
      search,
      status,
      departments,
      locations,
    })
      .mergeMap((resultingActions) => [...resultingActions, fetchSuccessAction()].filter(Boolean))
      .takeUntil(action$.ofType(INIT, SET_FETCH_PARAMS))
      .catch((e) => Observable.of(fetchFailedAction(e)));
  });

const verify = (action$, store) =>
  action$.ofType(VERIFY).mergeMap(({ userId, state }) =>
    VolunteersApi.verify(selectOrganization(store.getState()), userId, state)
      .mergeMap((resultingActions) => [...resultingActions, verifySuccessAction(userId)])
      .catch((e) => Observable.of(verifyFailedAction(e, userId)))
  );

const sendPACUploadEmailNotification = (action$: ActionsObservable<SendPacUploadEmailAction>) =>
  action$.ofType(SEND_PAC_UPLOAD_EMAIL_NOTIFICATION).exhaustMap(({ message }) =>
    VolunteersApi.sendPACUploadEmailNotification(message)
      .mergeMap(() => [
        showMessageAction('SUCCESS: Deed was notified of the PAC Upload'),
        sendPacUploadEmailSuccessAction(),
      ])
      .catch((e) =>
        Observable.of(
          sendPacUploadEmailFailedAction(e),
          showErrorAction('ERROR: Could not send email notification')
        )
      )
  );

export default [fetch, verify, sendPACUploadEmailNotification];
